<div class="layout user-profile-info">
  <mat-toolbar color="primary h-[48px]!" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="2px">
    <div class="regular-toolbar-section" fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <span class="regular-toolbar-label"
        >{{ $safeNavigationMigration(user()?.firstname) | uppercase }} {{ $safeNavigationMigration(user()?.lastname) | uppercase }}</span
      >
      @if (loading()) {
        <mat-progress-spinner mode="indeterminate" [diameter]="20" class="regular-loader" color="accent" />
      }
    </div>
  </mat-toolbar>

  @if (user()) {
    <div
      fxLayout="column"
      fxLayoutAlign="start center"
      fxLayoutGap="50px"
      class="user-profile-info__container layout__wrapper max-w-4xl pt-8 pr-12 pb-8 pl-12 sm:mb-4 sm:p-4 xl:max-w-4xl"
    >
      <div fxLayout="row" fxFlexFill fxLayoutGap="50px">
        <oyan-ui-users-user-profile-info [currentUser]="user()" fxFlex="50%" (editUserProfile)="editUserProfile()" />
        <oyan-ui-user-profile-preferences fxFlex="50%" [currentUser]="user()" (changeUserPreferences)="changeUserPreferences()" />
      </div>

      <div fxLayout="row" fxFlexFill>
        <iot-platform-ui-user-related-business-profiles fxFlex [currentUser]="user()" />
      </div>
    </div>
  }
</div>
